import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PageNotFound from "./PageNotFound";
import TVGuide from "./TVGuide";
import GameStudio from "./GameStudio";
import MediaStudio from "./MediaStudio";
import PoliticalComic from "./PoliticalComic";
import PacMan from "./components/PacMan";
import Hangman from "./components/Hangman";
import SkyHopper from "./components/SkyHopper";
import NeonSnake from "./components/NeonSnake";
import WordLadders from "./components/WordLadders";
import JigsawPuzzle from "./components/JigsawPuzzle";
import MovieCrossword from "./components/MovieCrossword";
import {ProgrammeDetailsPage} from "./components/ProgrammeDetailsPage";

function App() {
    return (<BrowserRouter>
        <Routes>
            <Route path="/south-africa" element={<TVGuide country={'south-africa'}/>}/>
            <Route path="/nigeria" element={<TVGuide country={'nigeria'}/>}/>
            <Route path="/game-studio/nigeria" element={<GameStudio country={'nigeria'}/>}/>
            <Route path="/game-studio/south-africa" element={<GameStudio country={'south-africa'}/>}/>
            <Route path="/media/nigeria" element={<MediaStudio country={'nigeria'}/>}/>
            <Route path="/media/south-africa" element={<MediaStudio country={'south-africa'}/>}/>
            <Route path="/political-comic/nigeria" element={<PoliticalComic country={'nigeria'}/>}/>
            <Route path="/political-comic/south-africa" element={<PoliticalComic country={'south-africa'}/>}/>
            <Route path="/dot-eater/nigeria" element={<PacMan country={'nigeria'}/>}/>
            <Route path="/dot-eater/south-africa" element={<PacMan country={'south-africa'}/>}/>
            <Route path="/hangman/nigeria" element={<Hangman country={'nigeria'}/>}/>
            <Route path="/hangman/south-africa" element={<Hangman country={'south-africa'}/>}/>
            <Route path="/sky-hopper/nigeria" element={<SkyHopper country={'nigeria'}/>}/>
            <Route path="/sky-hopper/south-africa" element={<SkyHopper country={'south-africa'}/>}/>
            <Route path="/neon-snake/nigeria" element={<NeonSnake country={'nigeria'}/>}/>
            <Route path="/neon-snake/south-africa" element={<NeonSnake country={'south-africa'}/>}/>
            <Route path="/word-ladders/nigeria" element={<WordLadders country={'nigeria'}/>}/>
            <Route path="/word-ladders/south-africa" element={<WordLadders country={'south-africa'}/>}/>
            <Route path="/jigsaw/nigeria" element={<JigsawPuzzle country={'nigeria'}/>}/>
            <Route path="/jigsaw/south-africa" element={<JigsawPuzzle country={'south-africa'}/>}/>
            <Route path="/crossword/nigeria" element={<MovieCrossword country={'nigeria'}/>}/>
            <Route path="/crossword/south-africa" element={<MovieCrossword country={'south-africa'}/>}/>
            <Route path="/programme/:country/:eventId" element={<ProgrammeDetailsPage/>}/>
            <Route path="*" element={<PageNotFound/>}/>
            <Route path="/" element={<TVGuide country={'south-africa'}/>}>
            </Route>
        </Routes>
    </BrowserRouter>)
}

export default App;
